/**
 * Mappers for position update operations
 */

import type {
  LC_UpdatePositionIn,
  LC_UpdatePositionOut,
  UpdatePositionRequest,
  UpdatePositionResult,
} from '../types';


export function mapUpdatePositionToTransport(
  request: UpdatePositionRequest,
): LC_UpdatePositionIn {
  return {
    positionCode: request.code,
    positionName: request.name,
    description: request.description,
    areaId: request.areaId,
  };
}

export function mapUpdatePositionFromTransport(
  transport: LC_UpdatePositionOut,
): UpdatePositionResult {
  return {
    id: transport.positionId,
    code: transport.positionCode,
    name: transport.positionName,
    description: transport.description,
    areaId: transport.areaId,
    areaName: transport.areaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate || undefined,
    modifiedBy: transport.modifiedBy || undefined,
  };
}